module.exports = {"530322001":"中枢街道","530322002":"同乐街道","530322102":"板桥镇","530322103":"三岔河镇","530322104":"马街镇","530322105":"召夸镇","530322106":"大莫古镇","530322107":"芳华镇","530322108":"小百户镇","530322201":"活水乡","530322202":"龙海乡","530322501":"陆良华侨管理区（镇）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530322.json
// module id = 2557
// module chunks = 0